import $ from "jquery";
import debug from 'bows/dist/bows.min.js';

let $gallery = $('[data-slider="gallery"]');
const log = debug("sliders:gallery");

function setControls($self, $sn) {
  let currentImageHeight = $self.find('img').height();
  if ( currentImageHeight != 0 ) {
    $sn.css('top', currentImageHeight / 2);
  }
}

function slideWidth(img) {
  img.forEach((img) => {
    if (img.parentElement.nextElementSibling != null) {
      img.parentElement.nextElementSibling.setAttribute('style', 'max-width:' + img.clientWidth + 'px')
    }
  });
}

function sliderInit() {

  $gallery.each(function () {
    let $this = $(this);
    let role = $this.attr('role');
    let $gallery = $this.closest('.slider-gallery');
    let $sn = $gallery.find('.slider-nav');
    let $sb = $gallery.find('.slider-nav__arrows');
    let $sd = $gallery.find('.slider-nav__dots');
    let img = document.querySelectorAll('.slider-gallery__img img');
    let $progressBar = $gallery.find('.slider-progress');
    let $progressBarLabel = $gallery.find('.slider__label');

    if (role !== 'region') {
      let $slider = $this.slick({
        dots: false,
        mobileFirst: true,
        speed: 500,
        infinite: false,
        variableWidth: false,
        slidesToShow: 1,
        arrows: false,
        slidesToScroll: 1,
        touchThreshold: 20,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: false,
              variableWidth: true,
              arrows: true,
              appendArrows: $sb,
            }
          }
        ]
      });



      $slider.slickLightbox({
        imageMaxHeight: 1,
        background: 'rgba(0, 0, 0, .9)',
        useHistoryApi: 'true',
        caption: function (element, info) {
          return jQuery(element).next('.slider-gallery_caption').html();
        },
        src: 'data-img',
        itemSelector: '.slider-gallery__item img'
      }).on({
        'show.slickLightbox': function () {
          $('.slick-lightbox-slick-img').wrap('<div class="slick-lightbox-slick-img-wrap"></div>')
        }
      });

      setTimeout(() => {
        setControls($this.find('.slick-current'), $sn);
        slideWidth(img);
      }, 100);

      $slider.on('afterChange', function (event, slick, currentSlide) {
        setControls($this.find(`[data-slick-index="${currentSlide}"]`), $sn);
      });

      $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var calc = ((nextSlide) / (slick.slideCount - 1)) * 100;

        $progressBar
          .css('background-size', calc + '% 100%')
          .attr('aria-valuenow', calc);

        $progressBarLabel.text(calc + '% completed');
      });

      $(window).on('load', function () {
        slideWidth(img);
        setControls($this.find('.slick-current'), $sn);
      })

      $(window).on('resize', function () {
        setTimeout(() => {
          setControls($this.find('.slick-current'), $sn);
          slideWidth(img);
        }, 100);
      }).on('load', function () {
        setControls($this.find('.slick-current'), $sn);
      });
    }
  });
}

export function init() {
  if ($gallery.length) {
    sliderInit();
  }
}

export default {
  init
};
